import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * A list of changes, each showing what the school held beside what the parent entered.
 *
 * The old value is the point: a reviewer is deciding whether to replace it, which they cannot do
 * from the new value alone.
 */
const ChangeList = ({ changes = [] }) => {
    if (!changes.length) return null;

    return (
        <Box>
            {changes.map((change) => (
                <Box key={change.field} sx={{ mb: 1.75 }}>
                    <Typography sx={{ fontSize: '13px', color: '#64748b', mb: 0.25 }}>
                        {change.label || change.field}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                        <Typography sx={{ fontSize: '14px', color: '#b91c1c', textDecoration: 'line-through' }}>
                            {change.was || '—'}
                        </Typography>
                        <Typography sx={{ fontSize: '14px', color: '#94a3b8' }}>→</Typography>
                        <Typography sx={{ fontSize: '14px', color: '#065f46', fontWeight: 600 }}>
                            {change.now || '—'}
                        </Typography>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default ChangeList;
